module.exports = __webpack_public_path__ + "static/img/utube.ffac7ff8.png";